import { Component } from "@angular/core";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { AppLayoutComponent } from "../../../../shared/components/app-layout/app-layout.component";
import { PageHeaderComponent } from "../../../../shared/components/page-header/page-header.component";
import { MyAssignedEventsListContainerComponent } from "./my-assigned-events-list-container/my-assigned-events-list-container.component";
import { MyEventsListContainerComponent } from "./my-events-list-container/my-events-list-container.component";

const MY_EVENTS_SECTIONS_ENUM = {
  MY_EVENTS: "my_events",
  ASSIGNED_EVENTS: "assigned_events",
};

@Component({
  selector: "app-my-events-page",
  imports: [
    AppLayoutComponent,
    PageHeaderComponent,
    MyEventsListContainerComponent,
    MyAssignedEventsListContainerComponent,
    MatButtonToggleModule,
  ],
  templateUrl: "./my-events-page.component.html",
  styleUrl: "./my-events-page.component.scss",
})
export class MyEventsPageComponent {
  DISPLAY_SECTION_OPTIONS_ENUM = MY_EVENTS_SECTIONS_ENUM;

  sectionDisplay = this.DISPLAY_SECTION_OPTIONS_ENUM.MY_EVENTS;
}
